export default __webpack_public_path__ + "static/media/ROLEX.44de24ec.jpg";